import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class StatisticService {

  constructor(private httpClient: HttpClient) { }

  getCurrent(organization?: number) {
    return this.httpClient.get<{ data: ICurrentStatistic, success: boolean }>('/api/statistics/current', {params: organization ? {organization: organization} : null});
  }

  getHistorical(organization?: number) {
    return this.httpClient.get<{ data: ICurrentStatistic, success: boolean }>('/api/statistics/historical', {params: organization ? {organization: organization} : null});
  }

  getActiveDongles(organization?: number) {
    return this.httpClient.get<{ data: ICurrentStatistic, success: boolean }>('/api/statistics/dongleActivities', {params: organization ? {organization: organization} : null});
  }

  getUsersHistory(organization?: number) {
    return this.httpClient.get<{ data: any, success: boolean }>('/api/statistics/usersHistory', {params: organization ? {organization: organization} : null});
  }
}

export interface ICurrentStatistic {
  users: {
    usersCount: number,
    adminsCount: number,
  },
  carInstalls: ICarInstallsStatistic,
  carStatuses: ICarStatusesStatistic
  hubs: IHubStatistic[],
  numberOfCompanies: number,
  numberOfSites: number,
}

export interface ICarStatusesStatistic {
  all: number,
  alerted: number,
  warned: number,
  ok: number,
  inactive: number
}

export interface ICarInstallsStatistic {
  all: number,
  installedCount: number,
  notInstalledCount: number
}

export interface IHubStatistic {
  companyName: string,
  name: string,
  all: number,
  activeCount: number,
  inactiveCount: number,
  activityPercentage: number
}
